import React, { Fragment } from 'react';
import { getStory } from 'library/components/story-blok/services/get-story';
import withConfig from 'util/hoc/with-config';
import { resolve } from 'library/helpers/path-resolver';
import ComponentMapper from 'library/components/story-blok/component-mapper';
import { object } from 'prop-types';
import { hideStoryblockOnPath } from 'apps/journey/util/location-specific-config';

class StoryBlokFooter extends React.Component {
  state = {
    footer: [],
  };
  componentDidMount() {
    this.getFooterStory();
  }

  getFooterStory = async () => {
    const { configuration } = this.props;
    const footerStory = await getStory(
      `${resolve(
        this.props.configuration,
        'environment/storyblok_root',
        'journey'
      )}/footer`,
       resolve(configuration,'environment/journey/entity/name', '').toLowerCase(),
        'footer'
    );
    this.setState({ footer: footerStory });
  };

  render() {
    return (
      !hideStoryblockOnPath() && (
        <Fragment>
          {resolve(this.state.footer, 'story/content/body', []).map((c, i) => (
            <ComponentMapper key={i} {...c} />
          ))}
        </Fragment>
      )
    );
  }
}

StoryBlokFooter.propTypes = {
  configuration: object,
};

export default withConfig(StoryBlokFooter);
